// removed by extract-text-webpack-plugin
module.exports = {"root":"_2YPsv","tabItem":"_3THE4","active":"_Wd_yJ"};


//////////////////
// WEBPACK FOOTER
// ./app/components/OutlineTabs/OutlineTabs.scss
// module id = 1504
// module chunks = 1